import {CmsReactComponent} from 'components/cms/CmsReactComponent';
import {
    EntryOptions,
    PropertyDefinition,
} from "app/library/layout-builder";
import {MembershipProps} from "./types";
import {MetaTypeEnum} from "app/shared";
import {MembershipPropertyDefinitions} from 'components/cms/definitions';

export class MembershipDefinitions extends CmsReactComponent<MembershipProps> {
    static defaultProps = {};

    static schemaName = "membership";

    static propertyDefinitions: PropertyDefinition[] = MembershipPropertyDefinitions;

    static options: EntryOptions = {
        meta: {
            use: true,
            allowedTypes: [
                MetaTypeEnum.Text,
                MetaTypeEnum.TextArea,
                MetaTypeEnum.SingleImage,
                MetaTypeEnum.Editor,
            ],
        },
    };

}
